import { useSuspenseQuery } from "@apollo/client/react";
import {
  GetReferenceDetailDocument,
  type GetReferenceDetailQuery,
  type GetReferenceDetailQueryVariables,
} from "~/features/references/gqls";
import { useTenant } from "~/features/tenant/context";

/** Read a single reference (detail fields + latest file) for the current tenant. */
export function useReferenceDetail(id: string) {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  return useSuspenseQuery<GetReferenceDetailQuery, GetReferenceDetailQueryVariables>(GetReferenceDetailDocument, {
    variables: { tenantId, id },
  });
}
